/**
 * One "self-managed" rule (#5413 KTD1), read by BOTH apps.
 *
 * An athlete manages their own account when a parent_athlete_relationships
 * row's parent_id equals the athlete's own login (athletes.auth_user_id).
 * Decide it by that login match — never by the relationship label ('self' /
 * 'parent'). The legacy athletes.is_independent flag no longer counts
 * (#5413 U11); the column is still written false for old phone builds.
 *
 * Shared so the web dashboard and the phone app cannot drift. The database
 * reads stay in each app (web: getSelfManagedAthleteIds in
 * parentAthleteRelationships.ts).
 *
 * THIS MODULE MUST STAY DEPENDENCY-FREE and compile without babel helpers:
 * no imports, no classes, no spread, no for...of (see
 * sharedModuleStaysDependencyFree.test.ts and
 * sharedModulesEmitNoBabelHelpers.test.ts).
 */

export interface SelfManagedAthleteFields {
  auth_user_id?: string | null;
}

/** True when this relationship row is the athlete's own account-holder row. */
export function isSelfRelationshipRow(
  row: { parent_id?: string | null },
  athlete: { auth_user_id?: string | null }
): boolean {
  return !!athlete.auth_user_id && row.parent_id === athlete.auth_user_id;
}

/**
 * True when the athlete manages their own account: one of
 * `relationshipParentIds` is the athlete's own login.
 */
export function isSelfManagedAthlete(
  athlete: SelfManagedAthleteFields,
  relationshipParentIds: ReadonlyArray<string | null | undefined>
): boolean {
  if (!athlete.auth_user_id) return false;
  for (let i = 0; i < relationshipParentIds.length; i += 1) {
    if (isSelfRelationshipRow({ parent_id: relationshipParentIds[i] }, athlete)) return true;
  }
  return false;
}
